import { render, staticRenderFns } from "./baseEdit.vue?vue&type=template&id=6b900e2a&scoped=true"
import script from "./baseEdit.vue?vue&type=script&lang=js"
export * from "./baseEdit.vue?vue&type=script&lang=js"
import style0 from "./baseEdit.vue?vue&type=style&index=0&id=6b900e2a&prod&lang=scss&scoped=true"
import style1 from "./baseEdit.vue?vue&type=style&index=1&id=6b900e2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b900e2a",
  null
  
)

export default component.exports